import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIResponse } from '../interfaces/api.interface';
import { DropOffLocation, DropOffLocationCreate, DropOffLocationSearchParams, DropOffLocationUpdate } from '../interfaces/drop-off-location.interface';
import { queryParamString } from '../utils/query-param-string';
import { ApiService } from './api.service';

  @Injectable({
    providedIn: 'root',
  })
  export class DropOffLocationService {
    public constructor(private readonly api: ApiService) {}

    /**
     * Search locations
     * @param organisationId 
     * @param params 
     * @param admin 
     * @returns 
     */
    public search(params?: DropOffLocationSearchParams, admin = false): Observable<APIResponse<DropOffLocation[]>> {
      const path: string = admin ? queryParamString(`admin/drop-off-locations`, params) : queryParamString(`organisations/${params?.organisationId}/options/drop-off-locations`, params);

      return this.api.get<APIResponse<DropOffLocation[]>>(path);
    }

    /**
     * Get all locations
     * 
     * @param organisationId 
     * @returns 
     */
    public get(organisationId: string): Observable<APIResponse<DropOffLocation[]>> {
      return this.api.get<APIResponse<DropOffLocation[]>>(`organisations/${organisationId}/options/drop-off-locations`);
    }

    /**
     * Get one location
     * 
     * @param id
     * @param admin
     * @param organisationId
     * @returns 
     */
    public getOne(id: string, admin = false, organisationId?: string ): Observable<DropOffLocation> {
      const path: string = admin ? `admin/drop-off-locations/${id}` : `organisations/${organisationId}/options/drop-off-locations/${id}`;

      return this.api.get<DropOffLocation>(path);
    }

    /**
     * Creates a new location. 
     * 
     * @param data 
     * @param admin 
     * @returns 
     */
    public create(data: DropOffLocationCreate, admin = false): Observable<DropOffLocation> {
      const path: string = admin ? `admin/drop-off-locations` : ''; // Currently no admin path for create.

      return this.api.post<DropOffLocation, DropOffLocationCreate>(path, data);
    }

    /**
     * Updates a location. 
     * 
     * @param data 
     * @param admin 
     * @returns 
     */
    public update(id: string, data: DropOffLocationUpdate, admin = false): Observable<DropOffLocation> {
      const path: string = admin ? `admin/drop-off-locations/${id}` : ''; // Currently no admin path for update.

      return this.api.put<DropOffLocation, DropOffLocationUpdate>(path, data);
    }

    /**
     * Archive
     * 
     * @param id 
     * @param admin 
     * @returns 
     */
    public archive(id: string, admin = false): Observable<DropOffLocation> {
      const path: string = admin ? `admin/drop-off-locations/${id}/archive` : ''; // Currently no admin path for create.

      return this.api.put<DropOffLocation, object>(path, {});
    }

    /**
     * Unarchive
     * 
     * @param id 
     * @param admin 
     * @returns 
     */
    public unarchive(id: string, admin = false): Observable<DropOffLocation> {
      const path: string = admin ? `admin/drop-off-locations/${id}/unarchive` : ''; // Currently no admin path for create.

      return this.api.put<DropOffLocation, object>(path, {});
    }
}